var path = '/templates/core/components/increase_or_decrease_percentage/increase_or_decrease_percentage.html';
var html = "<span class=increase-or-decrease ng-if=$ctrl.showValue ng-class=\"{ 'positive': $ctrl.percentage >= 0, 'negative': $ctrl.percentage < 0 }\">{{ $ctrl.showValue }}</span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../app_shared/src/shared_modules/core/components/increase_or_decrease_percentage/increase_or_decrease_percentage.html
// module id = 1358
// module chunks = 0